// Receipt's page states plus NO_INTEGRATION: enrolled (active or pending), but Shopify and
// Stripe are both disconnected, so there is no order data to prove a purchase with.
export const CE_PAGE_STATE = Object.freeze({
  ACTIVE: "active",
  NOT_ENROLLED: "not_enrolled",
  PENDING: "pending",
  NO_INTEGRATION: "no_integration"
})
